/**
 * Sentinel customer id that switches the consultation into public demo mode.
 *
 * When the consultation URL's `?id=` equals this value, the page renders a
 * captured mock snapshot (no `GetReportv2` / `GetConsultation` calls), requires
 * no authentication, and runs self-guided (the AI agent is disabled). Reusing
 * the normal `id` param — rather than a visible `?demo=1` flag — means the demo
 * link looks like any other consultation link.
 *
 * Kept in its own lightweight module (separate from `demoData.ts`) so importing
 * this constant never pulls the multi-MB fixture JSON into the caller's bundle.
 * The fixtures are loaded via dynamic `import("./demoData")` only in demo mode.
 */
export const DEMO_CONSULTATION_ID = "000000";

/** True when the given URL id is the demo sentinel. */
export const isDemoConsultationId = (id: string | null | undefined): boolean =>
  id === DEMO_CONSULTATION_ID;
